import type { CityConfig } from "../city-template/types";

export const spencerConfig: CityConfig = {
  city: "Spencer",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "spencer",
  route: "/cities/spencer",
  title: "Emergency Passport Spencer, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Spencer, IA — as fast as 24 hours. Serving Clay County and Northwest Iowa. A+ BBB rated registered State Dept. courier serving Iowa Great Lakes, agribusiness, and manufacturing professionals. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Spencer, IA",
  heroSubtitle: "Agribusiness executive with an urgent trade mission to Brazil? Iowa Great Lakes vacation home owner heading to Canada and your passport expired? Manufacturing plant manager with a surprise supplier visit to Germany? We help Spencer and Northwest Iowa residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Spencer%20Iowa%20downtown%20Grand%20Avenue%20historic%20Clay%20County%20Fairgrounds%20northwest%20Iowa%20small%20city%20at%20golden%20hour%20tree-lined%20streets%20Midwestern%20charm%20professional%20photography%20warm%20tones%20blue%20sky&width=1800&height=700&seq=spencer-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Spencer Iowa downtown Grand Avenue and Clay County Fairgrounds at golden hour",
  geoPosition: "43.1447;-95.1467",
  geoPlacename: "Spencer, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 370 miles east of Spencer via US-20 and I-88",
  },
  nearbyCitiesZips: [
    { name: "Spencer", zips: "51301" },
    { name: "Spirit Lake", zips: "51360" },
    { name: "Okoboji", zips: "51355" },
    { name: "Milford", zips: "51351" },
    { name: "Arnolds Park", zips: "51331" },
    { name: "Storm Lake", zips: "50588" },
    { name: "Emmetsburg", zips: "50536" },
    { name: "Estherville", zips: "51334" },
    { name: "Algona", zips: "50511" },
    { name: "Le Mars", zips: "51031" },
    { name: "Sioux City", zips: "51101–51111" },
    { name: "Sioux Falls", zips: "57101–57110" },
    { name: "Fort Dodge", zips: "50501" },
    { name: "Mason City", zips: "50401" },
    { name: "Waterloo", zips: "50701–50707" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Council Bluffs", zips: "51501–51503" },
    { name: "Omaha", zips: "68101–68164" },
    { name: "Worthington", zips: "56187" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Northwest Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Northwest Iowa Coverage", desc: "Serving Spencer, Iowa Great Lakes, and Clay County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Sioux City, IA", route: "/cities/sioux-city" },
    { name: "Fast passport renewal in Fort Dodge, IA", route: "/cities/fort-dodge" },
    { name: "Emergency passport help in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Urgent passport services in Sioux Falls, SD", route: "/cities/sioux-falls" },
    { name: "Same-day passport help in Mason City, IA", route: "/cities/mason-city" },
    { name: "Passport courier services in Waterloo, IA", route: "/cities/waterloo-ia" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Spencer remotely via secure courier. We do not have a walk-in office in Spencer — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Clay County and the entire Northwest Iowa region.",
  fpcOfficeAddress: "801 Grand Ave, Des Moines, Iowa 50309",
  fpcOfficeDistance: "Serving all of Clay County and Northwest Iowa including the Iowa Great Lakes region",
  serviceAreaIntro: "From the historic Grand Avenue downtown district and the Clay County Fairgrounds that host the world-famous Clay County Fair to the agricultural and manufacturing communities of Spencer, from the Iowa Great Lakes resorts of Okoboji and Spirit Lake to the Dutch heritage communities of Northwest Iowa, from the rural farmsteads of Clay County to the lakeside vacation homes along West Lake Okoboji — Fast Passport Center serves the entire Spencer and Northwest Iowa region. We regularly help travelers from Spencer, Spirit Lake, Okoboji, Storm Lake, and surrounding areas get their passports fast without the 3.5-hour drive to Minneapolis.",
  nearbyCitiesIntro: "We serve all Spencer neighborhoods and the surrounding Northwest Iowa area including Spirit Lake, Okoboji, Milford, Arnolds Park, Storm Lake, Emmetsburg, and Estherville. If you are anywhere in Clay County, Dickinson County, or the Iowa Great Lakes region, we have you covered.",
  howItWorksIntro: "Most Spencer travelers complete everything online and ship documents overnight. No need to drive to Minneapolis or wait in line at the regional agency.",
  mistakesIntro: "Northwest Iowa travelers often face a 3.5-hour drive to the nearest regional passport agency in Minneapolis. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Spencer and Clay County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Spencer? Here are the most common ones we hear from Northwest Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Iowa HHS Vital Records (Birth, Death)", url: "https://hhs.iowa.gov/vital-records", desc: "Official Iowa vital records office in Des Moines" },
    { icon: "ri-heart-pulse-line", label: "Clay County Recorder — Marriage Licenses", url: "https://www.claycounty.iowa.gov", desc: "Clay County Recorder — marriage records" },
    { icon: "ri-scales-line", label: "Iowa Courts — Divorce Records", url: "https://www.iowacourts.gov/", desc: "Iowa Judicial Branch — divorce decree records" },
    { icon: "ri-global-line", label: "VitalChek — Order Online", url: "https://www.vitalchek.com/", desc: "Official partner for online vital record orders" },
  ],
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Spencer travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Craig L.",
      location: "Spencer, IA",
      rating: 5,
      text: "Ag trade mission to Brazil with 4 days notice. My passport was expired and I was in a panic. Fast Passport Center renewed it in 2 days. I made my flight from Des Moines to Sao Paulo. Incredible service for Northwest Iowa.",
      service: "Passport Renewal",
    },
    {
      name: "The Johnsons",
      location: "Okoboji, IA",
      rating: 5,
      text: "Annual fishing trip to Canada from our Okoboji lake house — we forgot to check the kids' passports. Fast Passport Center had all three in 5 days. We drove across the border without a hitch. Lifesavers!",
      service: "Child Passport",
    },
    {
      name: "Marilyn R.",
      location: "Spirit Lake, IA",
      rating: 5,
      text: "Medical volunteer trip to Guatemala through our church in Spencer. I realized my passport was expired 8 days before departure. Fast Passport Center got it back in 4 days. I was able to serve on the mission.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "spencer-1",
      name: "Spencer Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14 E 4th St",
      city: "Spencer",
      state: "IA",
      zip: "51301",
      phone: "(712) 262-2711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Spencer",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Spencer facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "spencer-2",
      name: "Clay County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "300 W 4th St",
      city: "Spencer",
      state: "IA",
      zip: "51301",
      phone: "(712) 262-2702",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Spencer Courthouse",
      website: "https://www.claycounty.iowa.gov",
      websiteLabel: "Clay County Recorder",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "spencer-3",
      name: "Spirit Lake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1800 Hill Ave",
      city: "Spirit Lake",
      state: "IA",
      zip: "51360",
      phone: "(712) 336-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north in Spirit Lake",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Dickinson County and Iowa Great Lakes. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "spencer-4",
      name: "Storm Lake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "505 Erie St",
      city: "Storm Lake",
      state: "IA",
      zip: "50588",
      phone: "(712) 732-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles south in Storm Lake",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Buena Vista County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "spencer-5",
      name: "Sioux City Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "214 Jackson St",
      city: "Sioux City",
      state: "IA",
      zip: "51101",
      phone: "(712) 252-2000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "80 miles southwest in Sioux City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Woodbury County. Full passport services. Good option for southern Clay County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to Minneapolis", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Spencer photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Clay County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Spencer applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Minneapolis regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Clay County families at the county recorder.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Spencer travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Spencer." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Spencer address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Spencer before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Spencer for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Spencer?", a: "Fast Passport Center offers fast passport renewal in Spencer in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Spencer?", a: "The nearest regional passport agency to Spencer is the Chicago Passport Agency, approximately 370 miles east via US-20 and I-88. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Spencer without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Spencer?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5-plus hours from Spencer — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Clay County residents." },
    { q: "Do you serve the entire Iowa Great Lakes region?", a: "Absolutely. Fast Passport Center serves the entire Northwest Iowa region including Spencer, Spirit Lake, Okoboji, Milford, Arnolds Park, Storm Lake, and surrounding communities. Our courier service works seamlessly from any address in Clay County, Dickinson County, and the entire Iowa Great Lakes." },
    { q: "Can I expedite a child passport in Spencer?", a: "Yes. Fast Passport Center expedites child passports in Spencer for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Clay County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Spencer with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Spencer", address: "500 11th St SW, Spencer, IA 51301", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Spencer", address: "700 Grand Ave, Spencer, IA 51301", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Spirit Lake", address: "2200 17th St, Spirit Lake, IA 51360", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Spencer Driver's License",
      address: "1103 11th Ave SW, Spencer, IA 51301",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Clay County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Spirit Lake Driver's License",
      address: "1911 Keokuk Ave, Spirit Lake, IA 51360",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Dickinson County and Iowa Great Lakes. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Storm Lake Driver's License",
      address: "714 Michigan St, Storm Lake, IA 50588",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Buena Vista County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SPW",
      name: "Spencer Municipal Airport",
      distance: "3 miles northwest of Spencer",
      address: "1000 220th Ave, Spencer, IA 51301",
      note: "General aviation airport serving Clay County. Private and charter flights available. About 5 minutes from downtown Spencer.",
      flightUrl: "https://www.spenceriowacity.com/airport/",
      flightLabel: "SPW Airport",
      featured: true,
    },
    {
      code: "SUX",
      name: "Sioux Gateway Airport",
      distance: "80 miles southwest of Spencer",
      address: "2403 Aviation Blvd, Sioux City, IA 51111",
      note: "Regional airport with direct flights to major hubs. About 1 hour 20 minutes from Spencer.",
      flightUrl: "https://www.flysux.com/",
      flightLabel: "SUX Airport",
      featured: false,
    },
    {
      code: "FSD",
      name: "Sioux Falls Regional Airport",
      distance: "100 miles west of Spencer",
      address: "2801 Jaycee Ln, Sioux Falls, SD 57104",
      note: "Regional airport with direct flights to major hubs. About 1 hour 40 minutes from Spencer.",
      flightUrl: "https://www.sfairport.com/",
      flightLabel: "FSD Airport",
      featured: false,
    },
  ],
};